export default __webpack_public_path__ + "static/media/Location_icon.806713ec.svg";